import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ShopifyDescription() {
  return <section className="py-24 px-6 bg-nude-light" data-id="element-280">
      <div className="max-w-3xl mx-auto" data-id="element-281">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-10 md:p-14 rounded-2xl shadow-sm border border-nude" data-id="element-282">
          <div className="text-center mb-10" data-id="element-283">
            <span className="text-xs font-bold tracking-widest uppercase text-gold mb-2 block" data-id="element-284">
              Información del Producto
            </span>
            <h2 className="text-2xl md:text-3xl font-serif text-luxury-black" data-id="element-285">
              KIT PROFESIONAL PARA PESTAÑAS – ALEXA BEAUTY
            </h2>
          </div>

          <div className="space-y-6 text-gray-600 font-sans font-light leading-relaxed" data-id="element-286">
            <p data-id="element-287">
              Diseñado para lash artists, beauty professionals y mujeres que
              aman trabajar con estilo.
            </p>
            <p data-id="element-288">
              Este kit premium combina organización, elegancia y practicidad
              para que tengas todo lo necesario siempre contigo.
            </p>

            <ul className="space-y-3 py-4" data-id="element-289">
              {['Estuche premium elegante', 'Compartimentos internos inteligentes', 'Accesorios esenciales incluidos', 'Fácil de transportar', 'Ideal para uso profesional o personal'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-290">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-291" />
                  <span data-id="element-292">{item}</span>
                </li>)}
            </ul>

            <p data-id="element-293">Perfecto para citas, estudio o regalo especial.</p>

            <div className="pt-4 border-t border-gray-100" data-id="element-294">
              <p className="font-medium text-luxury-black mb-3" data-id="element-295">
                Disponible en:
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-296">
                <span className="inline-flex items-center gap-2 bg-rosado-soft px-4 py-2 rounded-full text-sm text-luxury-black border border-rosado-light/50" data-id="element-297">
                  🌸 Rosado Premium
                </span>
                <span className="inline-flex items-center gap-2 bg-luxury-black px-4 py-2 rounded-full text-sm text-white" data-id="element-298">
                  🖤 Negro Luxury
                </span>
              </div>
            </div>

            <p className="pt-4 font-serif text-lg italic text-luxury-black text-center" data-id="element-299">
              Haz que tu imagen profesional destaque desde el primer momento.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}